import { forwardRef } from 'react';

import { Badge, Group, MantineRadius, Select } from '@optiro/ui';

import { useProjectMilestones } from '@/hooks/useProjectMilestones';
import { ProjectMilestone } from '@/types/types';

type ProjectMilestoneSelectProps = {
  projectId: string | number;
  value?: ProjectMilestone['id'] | null;
  onChange: (value: string | null) => void;
  onDropdownClose?: () => void;
  label?: string;
  placeholder?: string;
  name?: string;
  radius?: MantineRadius;
  disabled?: boolean;
  variant?: 'default' | 'unstyled';
};

export const ProjectMilestoneSelect = forwardRef<HTMLInputElement, ProjectMilestoneSelectProps>(
  function ProjectMilestoneSelect(
    {
      projectId,
      value,
      onChange,
      onDropdownClose,
      label = '',
      placeholder = 'Vælg milepæl',
      radius = 'sm',
      name = 'milestone_id',
      disabled = false,
      variant,
    },
    ref
  ) {
    const { data: milestones, isLoading } = useProjectMilestones(projectId);

    return (
      <Select
        ref={ref}
        label={label}
        placeholder={isLoading ? 'Indlæser...' : placeholder}
        data={
          milestones
            ? milestones.map((m) => ({
                value: String(m.id),
                label: m.title,
              }))
            : []
        }
        name={name}
        radius={radius}
        variant={variant}
        clearable
        disabled={isLoading || disabled}
        value={String(value)}
        onChange={onChange}
        onDropdownClose={onDropdownClose}
        renderOption={({ option }) => (
          <Group gap="xs">
            <Badge color="blue" variant="light" size="sm">
              {option.label}
            </Badge>
          </Group>
        )}
      />
    );
  }
);
